import { ListItemIcon } from '@mui/material'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ClockIcon from '../../../assets/clock.svg'
import DeleteIcon from '../../../assets/delete.svg'
import FolderOpenIcon from '../../../assets/folder_open.svg'
import InfoIcon from '../../../assets/info.svg'
import PenIcon from '../../../assets/pen.svg'
import ShareIcon from '../../../assets/share.svg'
import { CustomTooltip } from '../../CustomTooltip'
import styles from './RowActionsMenu.module.css'
interface RowActionsMenuProps {
  anchorEl: HTMLElement | null
  id: string
  selectedRowId: string | null
  open: boolean
  handleClose: () => void
  onEditExperiment: () => void
  shouldShowAccessFiles: boolean
  onAccessFiles: () => void
  onDeleteExperiment: () => void
  onViewDetails: () => void
  onShareToTeams: () => void
  onViewHistory: () => void
  isEditDisabled: boolean
  isDeleteDisabled: boolean
  isBeforeYearBoundary: boolean
}

export const RowActionsMenu = ({
  anchorEl,
  id,
  open,
  handleClose,
  onEditExperiment,
  shouldShowAccessFiles,
  onAccessFiles,
  onDeleteExperiment,
  onShareToTeams,
  onViewDetails,
  onViewHistory,
  isEditDisabled,
  isDeleteDisabled,
  isBeforeYearBoundary,
}: RowActionsMenuProps) => {
  return (
    <div>
      <Menu
        id={id}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            className: styles.menuContainer,
          },
        }}>
        <MenuItem
          onClick={onViewDetails}
          className={styles.menuItem}>
          <ListItemIcon classes={{ root: styles.iconContainer }}>
            <img
              src={InfoIcon}
              className={styles.icon}
            />
          </ListItemIcon>
          <p className={styles.menuItemText}>View details</p>
        </MenuItem>
        {!isBeforeYearBoundary && (
          <CustomTooltip
            title={
              <span>
                You do not have <b>permission</b> to access this feature.
              </span>
            }
            placement="left"
            classes={{ tooltip: isEditDisabled ? styles.tooltip : styles.hiddenTooltip }}>
            <span>
              <MenuItem
                onClick={onEditExperiment}
                disabled={isEditDisabled}>
                <ListItemIcon classes={{ root: styles.iconContainer }}>
                  <img
                    src={PenIcon}
                    className={styles.icon}
                  />
                </ListItemIcon>
                <p className={styles.menuItemText}>Edit</p>
              </MenuItem>
            </span>
          </CustomTooltip>
        )}
        {shouldShowAccessFiles && (
          <MenuItem onClick={onAccessFiles}>
            <ListItemIcon classes={{ root: styles.iconContainer }}>
              <img
                src={FolderOpenIcon}
                className={styles.icon}
              />
            </ListItemIcon>
            <p className={styles.menuItemText}>Access files</p>
          </MenuItem>
        )}
        <MenuItem
          onClick={onViewHistory}
          className={styles.menuItem}>
          <ListItemIcon classes={{ root: styles.iconContainer }}>
            <img
              src={ClockIcon}
              className={styles.icon}
            />
          </ListItemIcon>
          <p className={styles.menuItemText}>History</p>
        </MenuItem>
        <MenuItem
          onClick={onShareToTeams}
          className={styles.menuItem}>
          <ListItemIcon classes={{ root: styles.iconContainer }}>
            <img
              src={ShareIcon}
              alt="Share"
              className={styles.icon}
            />
          </ListItemIcon>
          <p className={styles.menuItemText}>Share to Teams</p>
        </MenuItem>
        {!isBeforeYearBoundary && (
          <CustomTooltip
            title={
              <span>
                You do not have <b>permission</b> to access this feature.
              </span>
            }
            placement="left"
            classes={{ tooltip: isDeleteDisabled ? styles.tooltip : styles.hiddenTooltip }}>
            <span>
              <MenuItem
                onClick={onDeleteExperiment}
                disabled={isDeleteDisabled}>
                <ListItemIcon classes={{ root: styles.iconContainer }}>
                  <img
                    src={DeleteIcon}
                    className={styles.icon}
                  />
                </ListItemIcon>
                <p className={styles.menuItemText}>Delete experiment</p>
              </MenuItem>
            </span>
          </CustomTooltip>
        )}
      </Menu>
    </div>
  )
}
